import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const filterBadgeDefaultVariants = {}
const filterBadgeCompoundVariants = []

const filterBadgeSlotNames = [
  [
    "root",
    "filter-badge__root"
  ],
  [
    "input",
    "filter-badge__input"
  ],
  [
    "label",
    "filter-badge__label"
  ],
  [
    "icon",
    "filter-badge__icon"
  ]
]
const filterBadgeSlotFns = /* @__PURE__ */ filterBadgeSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, filterBadgeDefaultVariants, getSlotCompoundVariant(filterBadgeCompoundVariants, slotName))])

const filterBadgeFn = memo((props = {}) => {
  return Object.fromEntries(filterBadgeSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const filterBadgeVariantKeys = []
const getVariantProps = (variants) => ({ ...filterBadgeDefaultVariants, ...compact(variants) })

export const filterBadge = /* @__PURE__ */ Object.assign(filterBadgeFn, {
  __recipe__: false,
  __name__: 'filterBadge',
  raw: (props) => props,
  variantKeys: filterBadgeVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, filterBadgeVariantKeys)
  },
  getVariantProps
})